// extracted by mini-css-extract-plugin
export default {"collectionContainer":"landing-page__collectionContainer__qTUv6"};